"use client";

import { OESTRA_QUIZ_ENTRY_HREF } from "~/constants/oestraLandingPages";
import Container from "~/componentsDS/Layout/Container";
import Heading from "~/componentsDS/Typography/Heading";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
} from "~/components/ui/carousel";
import { useQuizLink } from "~/components/features/quiz";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";

import { PRODUCTS } from "./data";
import { ProductCard } from "./ProductCard";
import Reveal from "~/componentsDS/Reveal";

export default function ProductsSection() {
    const { href: oestraHref } = useQuizLink(OESTRA_QUIZ_ENTRY_HREF);
    const { href: libidaHref } = useQuizLink(QUIZ_ROUTES.LIBIDA);
    const { href: nadHref } = useQuizLink(QUIZ_ROUTES.NAD);

    const resolvedLinks: Record<string, string> = {
        [OESTRA_QUIZ_ENTRY_HREF]: oestraHref,
        [QUIZ_ROUTES.LIBIDA]: libidaHref,
        [QUIZ_ROUTES.NAD]: nadHref,
    };

    const products = PRODUCTS.map((product) => ({
        ...product,
        href: resolvedLinks[product.href] ?? product.href,
    }));

    return (
        <section className="overflow-hidden py-16 pt-14 text-primary500 md:pb-24 md:pt-20">
            <Container>
                <Reveal>
                    <Heading as="h2" className="text-center text-primary500">
                        Your health – <br className="md:hidden" />brought into <Heading as="i" font="featureDisplay" weight="400" className="text-[36px]">balance</Heading>
                    </Heading>
                </Reveal>

                <Carousel
                    className="-mx-6 mt-6 lg:mx-0 lg:mt-10"
                    opts={{
                        align: "start",
                        containScroll: "trimSnaps",
                        breakpoints: {
                            "(min-width: 1280px)": { active: false },
                        },
                    }}
                    loop={false}
                >
                    <CarouselContent className="ml-0 gap-4 px-6 xl:grid xl:grid-cols-[repeat(4,minmax(260px,1fr))] xl:gap-6 xl:px-0">
                        {products.map((product) => (
                            <CarouselItem
                                key={product.name}
                                className="basis-[240px] pl-0 md:basis-[300px] xl:basis-auto"
                            >
                                <ProductCard product={product} />
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                </Carousel>
            </Container>
        </section>
    );
}
